
const FACEBOOK_APP_ID = '';
const CACHED_KEY      = 'web_facebook_id';
const REDIRECT_URI    = window.location.origin;

function openFacebookPopup(): Promise<{ accessToken: string; userId: string; profileUrl?: string; pictureUrl?: string }>
{
  return new Promise( ( resolve, reject ) =>
  {
    const params = new URLSearchParams( {
      client_id:     FACEBOOK_APP_ID,
      redirect_uri:  REDIRECT_URI,
      response_type: 'token',
      scope:         'public_profile',
    } );

    console.log( '[FacebookWebSignIn] redirect_uri:', REDIRECT_URI );

    const popup = window.open(
      `https://www.facebook.com/dialog/oauth?${ params }`,
      'facebook-signin',
      'width=500,height=600,left=200,top=100'
    );

    if ( !popup )
    {
      reject( new Error( 'Popup blocked' ) );
      return;
    }

    let done = false;

    const clearAll = () =>
    {
      clearInterval( pollTimer );
      clearInterval( closeTimer );
    };

    const pollTimer = setInterval( async () =>
    {
      if ( done ) return;

      try
      {
        const hash = popup.location.hash;
        if ( !hash ) return;

        clearAll();
        done = true;
        popup.close();

        const hashParams = new URLSearchParams( hash.slice( 1 ) );
        const accessToken = hashParams.get( 'access_token' );

        if ( !accessToken )
        {
          const error = hashParams.get( 'error_description' ) ?? 'No access_token in response';
          reject( new Error( error ) );
          return;
        }

        // Get Facebook User ID and profile picture in one request
        const res = await fetch(
          `https://graph.facebook.com/me?fields=id,picture.type(large)&access_token=${ accessToken }`
        );
        const data = await res.json() as {
          id?: string;
          picture?: { data: { url: string; is_silhouette: boolean } };
          error?: { message: string };
        };

        if ( data.error )
        {
          reject( new Error( data.error.message ) );
          return;
        }

        const userId = data.id ?? '';
        const pictureUrl = data.picture?.data?.is_silhouette ? undefined : data.picture?.data?.url;

        console.log( '[FacebookWebSignIn] signed in, userId:', userId, 'hasPicture:', !!pictureUrl );
        resolve( { accessToken, userId, pictureUrl } );
      }
      catch
      {
        // Still on facebook.com — cross-origin, keep polling
      }
    }, 300 );

    const closeTimer = setInterval( () =>
    {
      if ( done ) return;
      if ( popup.closed )
      {
        done = true;
        clearAll();
        reject( new Error( 'Closed by user' ) );
      }
    }, 500 );
  } );
}

export const FacebookWebSignIn = {
  isAvailable(): boolean
  {
    return true;
  },

  getCachedId(): string | null
  {
    return localStorage.getItem( CACHED_KEY );
  },

  setCachedId( id: string ): void
  {
    localStorage.setItem( CACHED_KEY, id );
  },

  async signIn(): Promise<{ accessToken: string; userId: string; profileUrl?: string; pictureUrl?: string }>
  {
    return openFacebookPopup();
  },

  signOut(): void
  {
    localStorage.removeItem( CACHED_KEY );
  },
};
